<template>
    <v-layout row :style="isMobile?'margin:10px 0px 10px 0px;':'margin:10px 0px 10px 10px;'">
        <v-flex xs12>
                <span class="grey--text text--darken-2 caption">
                    By clicking  <b>BOOK NOW</b> button, you agree to <b>SweldoNow&copy</b>&nbsp;
                    <u @click="showPopup('terms')" style="cursor:pointer;" ><b>Terms & Conditions</b></u> 
                        and 
                    <u @click="showPopup('privacy')" style="cursor:pointer;"><b>Privacy Policy</b></u>.
                </span>
        </v-flex>
        <v-dialog v-model="dialog" width="700">
            <legal-docs-viewer ref="refViewer" :dialog.sync="dialog"></legal-docs-viewer>
        </v-dialog>
    </v-layout>
</template>
<script>
export default {
    data() {
        return {
            dialog: false,
            //static data for faster loading
            privacy_policy_data: {
                header: "Privacy Policy",
                effectiveDate: "February 9, 2024",
                intro: `At SweldoNow, we are committed to protecting the privacy and security of our customers' personal information. This Privacy Policy outlines the types of information we collect, how we use and safeguard it, and the choices you have regarding your personal data when using our cloud payroll system.`,
                details: [
                    {
                        title: "Information We Collect:",
                        description: "",
                        items: [
                            {
                                item: "Personal Information: We collect personal information that you provide to us, including but not limited to your name, email address, contact number, employee details, salary information, and other relevant data necessary for payroll processing."
                            },
                            {
                                item: "Usage Information: We automatically collect certain information, including device type, browser type, access times, and pictures used for clock-in/out attendance management and two-factor authentication. This data is collected to ensure system compatibility, analyze usage patterns, enhance security, and provide accurate attendance records."
                            },
                            {
                                item: "Face Data: When using features that involve facial recognition (e.g., clock-in/out attendance or identity verification), we collect facial data through Face AI. This data is processed locally on the device or within secure servers to authenticate users and improve attendance accuracy."
                            }
                        ]
                    },
                    {
                        title: "Use of Information:",
                        description: "",
                        items: [
                            {
                                item: "Payroll Processing: We collect and process personal information for the purpose of payroll processing and related services, including tax calculations, deductions, and generating payslips."
                            },
                            {
                                item: "Communication: We may use your contact information to communicate with you regarding your payroll, updates, service-related announcements, and customer support inquiries."
                            },
                            {
                                item: `System Improvement: We may analyze usage patterns and feedback to enhance our system's performance, develop new features, and improve user experience.`
                            },
                            {
                                item: "Face Data Utilization: Face data is used solely for clock-in/out attendance management, fraud prevention, and security enhancement. This data is never shared with third parties or used for marketing purposes."
                            },
                            {
                                item: "Legal Compliance: We may disclose personal information if required by law or in response to valid legal requests, such as subpoenas, court orders, or government regulations."
                            }
                        ]
                    },
                    {
                        title: "Data Security:",
                        description: "",
                        items: [
                            {
                                item: "Safeguards: We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. These measures include encryption, firewalls, access controls, and regular security assessments."
                            },
                            {
                                item: "Face Data Protection: Face data collected is encrypted and stored securely, ensuring it is only accessible for its intended purpose. We do not retain face data longer than necessary to fulfill its function."
                            },
                            {
                                item: "Data Transfer: We ensure that personal information transferred to and stored on our servers is done in a secure manner, utilizing encryption and secure protocols."
                            }
                        ]
                    },
                    {
                        title: "Data Retention:",
                        description: "We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. Upon termination of your account or request for deletion, we will securely dispose of your personal information in accordance with our data retention practices.",
                        items: []
                    },
                    {
                        title: "Your Rights:",
                        description: "",
                        items: [
                            {
                                item: "Access and Correction: You have the right to access and correct your personal information stored in our system. You can review, update, or delete your information by contacting our support team."
                            },
                            {
                                item: "Face Data Control: You can opt out of facial recognition features by contacting support or deactivating face recognition attendance tracking directly within SweldoNow. Please refer to the User Guide for detailed steps on how to manage this setting. Note that opting out may limit certain functionalities such as clock-in/out attendance tracking."
                            },
                            {
                                item: "Marketing Communications: You can opt out of receiving marketing communications from us by following the unsubscribe instructions provided in the communication or by contacting us directly."
                            }
                        ]
                    },
                    {
                        title: "Third-Party Services:",
                        description: "We may engage third-party service providers to perform functions on our behalf, such as payment processing or system maintenance. These providers may have access to your personal information only to the extent necessary to perform their services and are obligated to protect it in a manner consistent with this Privacy Policy.",
                        items: []
                    },
                    {
                        title: "Updates to Privacy Policy:",
                        description: `We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any material updates by email or through our system's interface. Please review the Privacy Policy periodically to stay informed about how we collect, use, and protect your personal information.`,
                        items: []
                    },
                    {
                        title: "Contact Us:",
                        description: "If you have any questions, concerns, or requests regarding this Privacy Policy or the handling of your personal information, please contact us at support@sweldonow.ph",
                        items: []
                    }
                ],
                footer: `By using SweldoNow's cloud payroll system, you acknowledge that you have read and understood this Privacy Policy and consent to the collection, use, and disclosure of your personal information as described herein.`
            },
            terms_conditions_data: {
                header: "Terms and Conditions",
                effectiveDate: "February 9, 2024",
                intro: "These Terms and Conditions (\"Terms\") govern your use of the SweldoNow cloud payroll system (referred to as \"SweldoNow\" or the \"Service\"), provided by SweldoNow OPC, a company registered in the Philippines. By using SweldoNow, you agree to comply with and be bound by these Terms. Please read them carefully.",
                details: [
                    {
                        title: "Acceptance of Terms",
                        description: "By accessing or using SweldoNow, you acknowledge that you have read, understood, and agreed to these Terms. If you do not agree with any part of these Terms, you may not use SweldoNow.",
                        items: []
                    },
                    {
                        title: "Description of Service",
                        description: "SweldoNow is a cloud-based payroll system that enables businesses to manage their payroll processes efficiently. The Service includes features such as employee data management, payroll calculation, tax computation, leave management, reporting, and optional face recognition attendance tracking. SweldoNow may add or remove features or functionalities at its discretion.",
                        items: []
                    },
                    // {
                    //     title: "Free Plan",
                    //     description: "SweldoNow offers a Free Plan for businesses looking to manage their payroll without incurring costs. The Free Plan includes standard payroll features with limited support and advertisements displayed on the login page.",
                    //     items: [
                    //         {
                    //             item: "The Free Plan is available to all businesses without any subscription fees."
                    //         },
                    //         {
                    //             item: "Access to certain advanced features may require upgrading to a paid plan."
                    //         },
                    //         {
                    //             item: "Advertisements are displayed within the login page for Free Plan users."
                    //         }
                    //     ]
                    // },
                    // {
                    //     title: "Prohibition on Reselling Services",
                    //     description: "Users or companies subscribed to the Free Plan are strictly prohibited from selling, reselling, or offering SweldoNow services as a paid service to third parties. The Free Plan is intended for personal or internal business use only, and any commercial redistribution of the Service is a violation of these Terms. SweldoNow reserves the right to terminate or suspend access to the Service for any user or company found in breach of this provision.",
                    //     items: []
                    // },
                    {
                        title: "SweldoNow Face AI",
                        description: "SweldoNow Face AI is a cloud and AI-based face recognition attendance tracker designed to work on standard cellphones or tablets. It streamlines attendance tracking with high accuracy and real-time updates and is fully integrated with SweldoNow payroll services.",
                        items: [
                            {
                                item: "The service collects and processes facial data solely for attendance tracking purposes."
                            },
                            {
                                item: "Facial data is securely stored and processed in compliance with applicable data privacy laws."
                            },
                            {
                                item: "Users must obtain consent from employees before utilizing the face recognition feature."
                            },
                            {
                                item: "SweldoNow Face AI requires an active internet connection for optimal functionality."
                            }
                        ]
                    },
                    {
                        title: "Registration and Account Security",
                        description: "To use SweldoNow, you must create an account and provide accurate and complete registration information. You are responsible for maintaining the confidentiality of your account credentials and are fully responsible for all activities that occur under your account. You must notify SweldoNow immediately of any unauthorized use or suspected breach of security.",
                        items: []
                    },
                    {
                        title: "Data Privacy and Security",
                        description: "SweldoNow takes data privacy and security seriously. By using the Service, you agree to comply with SweldoNow's Privacy Policy, which explains how your personal data is collected, used, and protected. SweldoNow employs industry-standard security measures to protect your data; however, no system is entirely foolproof, and SweldoNow cannot guarantee absolute security.",
                        items: []
                    },
                    {
                        title: "User Responsibilities",
                        description: "",
                        items: [
                            {
                                item: "You are responsible for ensuring the accuracy and completeness of all information you provide to SweldoNow."
                            },
                            {
                                item: "You agree not to use SweldoNow for any illegal, unauthorized, or unethical purposes."
                            },
                            {
                                item: "You are responsible for maintaining the confidentiality of any login credentials or other account information."
                            },
                            {
                                item: "You agree not to interfere with or disrupt the operation of SweldoNow or the networks connected to it."
                            },
                            {
                                item: "You will not copy, reproduce, distribute, or modify any part of the Service without prior written consent from SweldoNow."
                            },
                            {
                                item: "You will not attempt to gain unauthorized access to SweldoNow's systems or reverse engineer any part of the Service."
                            }
                        ]
                    },
                    {
                        title: "Payment and Subscription",
                        description: "",
                        items: [
                            {
                                item: "SweldoNow offers different subscription plans with various features and pricing options. Details of the plans and their associated costs are available on the SweldoNow website."
                            },
                            {
                                item: "You agree to pay all fees associated with your chosen subscription plan as outlined during the registration process."
                            },
                            {
                                item: "Payments for subscriptions are typically billed in advance and are non-refundable."
                            },
                            {
                                item: "SweldoNow may modify the pricing or features of its subscription plans. Any such changes will be communicated to you in advance."
                            },
                            {
                                item: "Failure to pay subscription fees may result in suspension or termination of your access to SweldoNow."
                            }
                        ]
                    },
                    {
                        title: "Intellectual Property Rights",
                        description: "SweldoNow retains all rights, title, and interest in and to the Service, including all intellectual property rights. You may not use any trademarks, logos, or other proprietary information of SweldoNow without prior written consent.",
                        items: []
                    },
                    {
                        title: "Limitation of Liability",
                        description: "SweldoNow acknowledges its responsibility to provide the Service with reasonable care and skill. However, to the fullest extent permitted by applicable law, SweldoNow shall not be liable for any direct, indirect, incidental, consequential, or exemplary damages, including but not limited to loss of profits, data, or use, arising out of or in connection with your use of the Service.",
                        items: []
                    },
                    {
                        title: "Termination",
                        description: "",
                        items: [
                            {
                                item: "You may terminate your use of SweldoNow at any time by contacting customer support or following the account closure procedure specified by SweldoNow."
                            },
                            {
                                item: "SweldoNow reserves the right to terminate or suspend your access to the Service without prior notice if you violate these Terms."
                            },
                            {
                                item: "Upon termination, your access to your account and data stored on SweldoNow may be disabled, and SweldoNow shall not be liable for any loss of data."
                            }
                        ]
                    },
                    {
                        title: "Modifications to Terms",
                        description: "SweldoNow reserves the right to modify or update these Terms at any time. The most current version of the Terms will be available on the SweldoNow website. By continuing to use the Service, you agree to be bound by the revised Terms.",
                        items: []
                    },
                    {
                        title: "Governing Law and Jurisdiction",
                        description: "These Terms shall be governed by and construed in accordance with the laws of the Republic of the Philippines. Any disputes arising out of or relating to these Terms or the Service shall be subject to the exclusive jurisdiction of the courts located in the Philippines.",
                        items: []
                    }
                ],
                footer: "If you have any questions or concerns about these Terms, please contact SweldoNow customer support."
            }
        }
    },
    components: {
        'legal-docs-viewer': () => import("@/components/LegalDocsViewer"),
    },
    methods: {
        showPopup(type) {
            if (type=='terms') {
                this.$refs.refViewer.setData(this.terms_conditions_data)
            }else{
                this.$refs.refViewer.setData(this.privacy_policy_data)
            }
            this.dialog = true
        }
    },
}
</script>
